import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { networkDelay } from '@/test/mocks/utils';

import type { GetOverviewResponse } from '../types';

// service-user wraps every parent-connect response in the standard
// `{ status, responseBody, ... }` envelope; the axios response
// interceptor in `lib/axios.ts` already unwraps the outer HTTP
// response, so we type the inner envelope here.
type ServiceUserEnvelope<T> = {
  message?: string;
  status?: string;
  responseBody?: T;
  errorCode?: number;
  errorMessage?: string | null;
};

export const getParentConnectOverview = async (
  variantId: string
): Promise<GetOverviewResponse> => {
  const data: ServiceUserEnvelope<GetOverviewResponse> = await axios.get(
    '/user/v1/trainer-slots/parent-connect/sessions',
    { params: { variant_id: variantId } }
  );
  return (
    data?.responseBody ?? {
      batch: {},
      teacher: {},
      student: {},
      pending_parent_connect_requests: [],
      approved_sessions: [],
    }
  );
};

export const getParentConnectOverviewMockHandler = http.get(
  `${env.API_URL}/user/v1/trainer-slots/parent-connect/sessions`,
  async () => {
    await networkDelay();
    return HttpResponse.json<ServiceUserEnvelope<GetOverviewResponse>>({
      status: 'SUCCESS',
      message: 'Parent connect overview fetched',
      errorCode: 0,
      errorMessage: null,
      responseBody: {
        batch: {
          batch_id: 'mock-batch-id',
          batch_name: 'Mock Math Batch',
          batch_type: 'batches',
          course: 'Math',
          grade: '6',
        },
        teacher: {
          teacher_id: 'mock-teacher-id',
          teacher_name: 'Mock Trainer',
        },
        student: {
          profile_id: 'mock-profile-id',
          student_name: 'Rupanshi',
          customer_timezone: 'Asia/Kolkata',
        },
        pending_parent_connect_requests: [],
        approved_sessions: [],
      },
    });
  }
);
